import { createFileRoute } from '@tanstack/react-router';
import InviteAccountTemplate from '@/features/agent/account/templates/InviteAccountTemplate';

export const Route = createFileRoute('/account/invite/$token')({
  component: InviteAccountPage,
});

function InviteAccountPage() {
  return <InviteAccountTemplate />;
}
